import { useContextError } from "common-frontend-components";
import { SectionContext, SectionsContext } from "./Contexts";

export const useSections = () => useContextError(SectionsContext.name, SectionsContext);

export const useSection = () => useContextError(SectionContext.name, SectionContext);
